<template>
  <div class="container">
    <form action="/">
      <van-search
        v-model="value"
        placeholder="请输入你要搜索的内容"
        shape="round"
        @search="onSearch()"
      />
    </form>
    <div class="main" v-for="item in list" :key="item.id">
      <a :href="item.link">
        <div class="img_video clearfix">
          <img :src="item.image" alt="...后端打野去了" />
        </div>
        <div class="video_title clearfix">
          <h1>{{ item.title }}</h1>
          <div class="disc">{{ item.introduction }}</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { getVideo2Data } from "@api/common";
import { search2Data } from "@api/common";
export default {
  data() {
    return {
      list: [],
      currentId: 1,
      info: [],
      lid: " "
    };
  },
  created() {
    // console.log(location.href);
    const lid = location.href.split("=")[1];
    // console.log(lid);
    this.getDataInfo(lid);
  },
  methods: {
    // 获取整体数据
    getDataInfo(id) {
      getVideo2Data({ lid: id }).then(res => {
        console.log(res);
        if (res.status === 200) {
          this.list = res.data;
          // console.log(res.data);
        }
      });
    },
    onSearch() {
      // console.log(this.value);
      search2Data({
        keyword: this.value,
        lid: location.href.split("=")[1]
      }).then(res => {
        // console.log(res);
        this.list = res.data;
      });
    }
  },
  computed: {}
};
</script>
<style scoped lang="scss">
.main {
  width: 100%;
  height: 2.6rem;
  margin-top: 20px;
  .clearfix {
    overflow: hidden;
  }
}
.container {
  background-color: #fff;
  .img_video {
    float: left;
    width: 40%;
    height: 2.5rem;
    margin-left: 20px;
    margin-top: 18px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .video_title {
    width: 50%;
    float: right;
    padding: 0.5rem 0.3rem 0rem 0rem;
    .disc {
      margin-top: 5px;
      color: #666;
      font-size: 0.25rem;
    }
  }
}
</style>
